export const selectIsLoggingIn = (state) => state?.auth?.isLoggingIn;
export const selectIsLoggedIn = (state) => state?.auth?.isLoggedIn;
export const selectAuthData = (state) => state?.auth?.data;
